import { render, staticRenderFns } from "./ScoreStartMachineArmy.vue?vue&type=template&id=095c057d&"
import script from "./ScoreStartMachineArmy.vue?vue&type=script&lang=js&"
export * from "./ScoreStartMachineArmy.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStartMachineArmy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports